import { SET_REGION } from "./actionTypes";

export const getRegion = () => {
  return async dispatch => {
    try {
      let res = await fetch("https://ipapi.co/json");
      res = await res.json();
      dispatch(setRegion(res.country));
    } catch (err) {
      console.log(err);
      dispatch(getRegion());
    }
  };
};
const setRegion = code => {
  return {
    type: SET_REGION,
    payload: code
  };
};
